import React from 'react';
import PublicHeader from './PublicHeader';

interface ClubRulesPageProps {
  onNavigateHome?: () => void;
  onNavigateToMission?: () => void;
  onNavigateToConduct?: () => void;
  onNavigateToWaiver?: () => void;
}

const ClubRulesPage: React.FC<ClubRulesPageProps> = ({ onNavigateHome, onNavigateToMission, onNavigateToConduct, onNavigateToWaiver }) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-blue-100">
      {/* Header */}
      <PublicHeader title="Official Club Rules" />

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
          {/* Title */}
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-fishing-blue mb-2">Tumbulgum Fishing Club Inc.</h2>
            <p className="text-gray-600 text-lg">Official Rules as at Jan 2025</p>
          </div>

          {/* Rules Sections */}
          <div className="space-y-8">
            {/* 1. Rules */}
            <section className="border-l-4 border-fishing-blue pl-6">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">1. Rules</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex">
                  <span className="font-semibold mr-2">(a)</span>
                  <span>All members must have a current NSW fishing licence and/or valid exemption.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(b)</span>
                  <span>ALL NSW DPI Fisheries rules apply to catch.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(c)</span>
                  <span>All boats need to be applicably registered and have correct safety gear at all times.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(d)</span>
                  <span>Fishing is ONLY permitted within the Tweed Shire. River, estuaries, rocks, headlands & beaches. Offshore fishing is not permitted.</span>
                </li>
              </ul>
            </section>

            {/* 2. Entry */}
            <section className="border-l-4 border-fishing-green pl-6">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">2. Entry</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex">
                  <span className="font-semibold mr-2">(a)</span>
                  <span>Registrations are between 7am and 9am, riverside across from the Tumbulgum Tavern.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(b)</span>
                  <span>Payment in full is required before entry to the competition is granted.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(c)</span>
                  <span>All competitors must sign a waiver.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(d)</span>
                  <span>All competitors must agree to the code of conduct & official rules.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(e)</span>
                  <span>Entry is $10 per entrant. $15 for non members.</span>
                </li>
              </ul>
            </section>

            {/* 3. Membership */}
            <section className="border-l-4 border-yellow-500 pl-6">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">3. Membership <span className="text-lg text-gray-600">(as of August 2025)</span></h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex">
                  <span className="font-semibold mr-2">(a)</span>
                  <span>Membership is: $30 per Junior, $40 per Adult, $120 per Family</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(b)</span>
                  <span>Family membership consists of 2 Adults / 3 Juniors.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(c)</span>
                  <span>Sponsors are entitled to 1 family membership.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(d)</span>
                  <span>Junior = 16 or under on 1 January of the membership year (they stay junior for the whole year)</span>
                </li>
              </ul>
            </section>

            {/* 4. Fishing in the comp */}
            <section className="border-l-4 border-teal-600 pl-6">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">4. Fishing in the Competition</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex">
                  <span className="font-semibold mr-2">(a)</span>
                  <span>Fishing time starts from 7am until 2pm (last fish received 2pm sharp).</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(b)</span>
                  <span>All fish being registered must be photographed on a brag mat with the current Tumbulgum Fishing club code and submitted via a club-approved method, as communicated for each competition. (All new members will receive a TFC brag mat) ANY digital enhancement or tampering with photos that result in, increase of size of fish or any advantage towards a win will be disqualified and will be subject to disciplinary action. Maximum penalty - return of all prizes won and 12 months disqualification, decided at the discretion of the committee.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(c)</span>
                  <span>All members are subject to the clubs, values, code of conduct and fishing club rules.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(d)</span>
                  <span>ALL NSW DPI Fisheries rules apply to catch.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(e)</span>
                  <span>All fish must be line caught and comply with DPI fishing rules - <a href="https://www.dpi.nsw.gov.au/fishing/recreational/fishing-rules-and-regs" target="_blank" rel="noopener noreferrer" className="text-fishing-blue hover:underline">https://www.dpi.nsw.gov.au/fishing/recreational/fishing-rules-and-regs</a></span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(f)</span>
                  <span>Undersized fish can be registered but must be released.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(g)</span>
                  <span>All fish must be caught by line. No nets, traps or drone fishing permitted.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(h)</span>
                  <span>All entries must be caught by the angler with the submission.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(i)</span>
                  <span>All entries must be caught during the allocated fishing hours 7am - 2pm.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(j)</span>
                  <div>
                    <p className="mb-2">3 biggest fish in each category win prizes.</p>
                    <p className="font-semibold mb-1">Categories are:</p>
                    <ul className="ml-4 space-y-1">
                      <li>• Bream</li>
                      <li>• Flathead</li>
                      <li>• Mangrove Jack</li>
                      <li>• Mulloway (Jewfish)</li>
                      <li>• Trevally</li>
                      <li>• Whiting</li>
                      <li>• Tailor</li>
                    </ul>
                  </div>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(k)</span>
                  <span>Bass (may be included at the discretion of the committee).</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(l)</span>
                  <span>Other species of fish may be entered, and additional prizes may be awarded at the discretion of the committee.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(m)</span>
                  <span>If the same size of any species is caught 1st, 2nd & 3rd will be determined by the time the entry was submitted.</span>
                </li>
              </ul>
            </section>

            {/* 5. Adjudication */}
            <section className="border-l-4 border-purple-600 pl-6">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">5. Adjudication</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex">
                  <span className="font-semibold mr-2">(a)</span>
                  <span>Is done by an independent adjudicator offsite not participating in the competition via iPad.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(b)</span>
                  <span>Winners then translated onto the 'winners' template' and announced verbally at the presentation and then transcribed to the 'leader board' located in the Tumbulgum Tavern.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(c)</span>
                  <span>ANY digital enhancement or tampering with photos that result in, increase of size of fish or any advantage towards a win will be disqualified and will be subject to disciplinary action and possible 12 months disqualification, decided at the discretion of the committee.</span>
                </li>
              </ul>
            </section>

            {/* 6. Presentation */}
            <section className="border-l-4 border-pink-600 pl-6">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">6. Presentation</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex">
                  <span className="font-semibold mr-2">(a)</span>
                  <span>Presentation will be held riverside across from the Tumbulgum Tavern at 4 pm on the day of the comp.</span>
                </li>
              </ul>
            </section>

            {/* 7. Prizes */}
            <section className="border-l-4 border-orange-600 pl-6">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">7. Prizes</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex">
                  <span className="font-semibold mr-2">(a)</span>
                  <span>First, second & third will be awarded $100, $50, $25 Addict tackle voucher respectively.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(b)</span>
                  <span>Top Bloke/Sheila award is at the discretion of the committee.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(c)</span>
                  <span>Mystery fish – Prize is $100 Addict Tackle voucher (The mystery fish size and species is decided by the sponsor of the prize or adjudicator prior to the commencement of the competition and is not disclosed to anyone. Prize jackpots each month if not won.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(d)</span>
                  <span>Members' draw prize is allocated at the discretion of the committee.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(e)</span>
                  <span>Anglers must be present to collect prizes.</span>
                </li>
              </ul>
              <div className="mt-4 p-4 bg-yellow-50 border-l-4 border-yellow-500 rounded">
                <p className="text-gray-800 font-semibold">Important:</p>
                <p className="text-gray-700">Anglers must be present (in-person) to receive a prize. All unclaimed prizes will go back into the prize pool. (Points toward the end of year champion competition will still be allocated to this competitor).</p>
              </div>
            </section>

            {/* 8. Special Awards */}
            <section className="border-l-4 border-indigo-600 pl-6">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">8. Special Awards</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex">
                  <span className="font-semibold mr-2">(a)</span>
                  <span><strong>Top bloke/Sheila</strong> – Awarded to a deserving member who helps or does a good deed and the prize allocated is at the discretion of the committee.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(b)</span>
                  <span><strong>Mystery fish</strong> – The fish and size are decided by the sponsor or the adjudicator so as to remain a secret from all competitors and the committee. The committee can decide if the mystery fish prize is a 'must go off', which means the closest entry to the nominated fish will win the prize.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(c)</span>
                  <span><strong>Lucky member draw(s)</strong> is drawn from the member list at random and the prize allocated is at the discretion of the committee, the member must be present to receive this prize. New members will be added to the prize pool in the following month from when they signed up.</span>
                </li>
              </ul>
            </section>

            {/* 9. Annual Champion */}
            <section className="border-l-4 border-red-600 pl-6">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">9. Calculation for Senior and Junior Annual Champion</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex">
                  <span className="font-semibold mr-2">(a)</span>
                  <span>Each monthly competition will score points for members that are either 1st, 2nd or 3rd in each category.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(b)</span>
                  <span>1st = 3 points, 2nd = 2 points, 3rd = 1 point</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(c)</span>
                  <span>Points are accumulated over the calendar year.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(d)</span>
                  <span>Senior & Junior members with the most points at the end of the year will receive the champion award.</span>
                </li>
                <li className="flex">
                  <span className="font-semibold mr-2">(e)</span>
                  <span>Senior, Junior champion and winners of each category will have their name emblazoned on the perpetual leaderboard displayed at the Tumbulgum Tavern.</span>
                </li>
              </ul>
            </section>
          </div>

          {/* Footer Note */}
          <div className="mt-12 p-6 bg-fishing-blue text-white rounded-lg">
            <p className="text-center text-lg">
              For questions about these rules, please contact the committee at fishing@tumbyfc.com
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12 px-4 mt-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-xl font-semibold mb-4">Contact Us</h3>
              <p className="text-gray-300">Website: www.tumbyfc.com</p>
              <p className="text-gray-300">Email: fishing@tumbyfc.com</p>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li><button onClick={onNavigateHome} className="text-gray-300 hover:text-white">Home</button></li>
                <li><button onClick={onNavigateToMission} className="text-gray-300 hover:text-white">Mission, Values & Vision</button></li>
                <li><button onClick={onNavigateToConduct} className="text-gray-300 hover:text-white">Code of Conduct</button></li>
                <li><button onClick={onNavigateToWaiver} className="text-gray-300 hover:text-white">Waiver & Release</button></li>
                <li><a href="/Constitution-Tumbulgum-Fishing-Club-V5.pdf" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">Club Constitution</a></li>
                <li><button className="text-gray-300 hover:text-white">Privacy Policy</button></li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-4">Location</h3>
              <p className="text-gray-300">Tumbulgum, New South Wales</p>
              <p className="text-gray-300">Australia</p>
            </div>
          </div>
          <div className="border-t border-gray-700 mt-8 pt-8 text-center">
            <p className="text-gray-400">&copy; 2026 Tumbulgum Fishing Club. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ClubRulesPage;
